<template>
  <div class="question">
    <div
      class="question-type"
      v-for="(question, qindex) in questionList"
      :key="qindex"
    >
      <div class="question-title displayflex align-center">
        <img :src="question.type_icon_url" alt="" />
        <div class="title">{{ question.type_name }}</div>
      </div>
      <div
        class="question-content"
        v-for="(item, cindex) in question.type_list"
        :key="cindex"
      >
        <div
          class="question-list displayflex align-center"
          @click="goQuestionDel(item)"
        >
          <div class="title">{{ item.case_name }}</div>
          <SvgIcon
            class="icon-right"
            name="arrowright"
            :size="16"
            color="#777"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "question",
  data() {
    return {
      questionList: [],
      courseKey: "",
    };
  },
  methods: {
    getQuestionList() {
      this.$api.my
        .questionListAPI()
        .then((data) => {
          this.questionList = data[this.courseKey]
            ? data[this.courseKey].list
            : [];
        })
        .catch(console.log);
    },
    goQuestionDel(item) {
      let caseContent = item.case_content || "";
      let caseName = item.case_name;
      localStorage.setItem("caseContent", caseContent);
      localStorage.setItem("caseName", caseName);
      localStorage.setItem("caseId", item.case_id);
      this.$router.push({
        name: "question_detail",
      });
    },
  },
  mounted() {
    let course = JSON.parse(this.$route.query.course || "{}");
    let courseInfo = [];
    for (let key in course) {
      if (course[key] === 1 || course[key] === true) {
        courseInfo.push(key);
      }
    }
    this.courseKey = courseInfo.length ? courseInfo.join("_") : "excellent";
    this.getQuestionList();
  },
};
</script>
<style lang="scss" scoped>
.displayflex {
  display: flex;
  display: -webkit-flex;
}
.align-center {
  align-items: center;
  -webkit-align-items: center;
}
.question {
  min-height: 100vh;
  background-color: #f5f5f7;
  padding-top: 8px;
  .question-type {
    width: 100%;
    margin-bottom: 8px;
    background-color: #ffffff;
  }
  .question-title {
    box-sizing: border-box;
    margin-left: 16px;
    font-size: 16px;
    font-weight: 500;
    height: 56px;
    img {
      width: 18px;
      height: auto;
      margin-right: 8px;
    }
    .title {
      font-size: 16px;
      font-weight: 500;
      color: #222;
    }
  }
  .question-list {
    width: 100%;
    height: 56px;
    border-top: 1px solid #e7e8ea;
    color: #5d646e;
    box-sizing: border-box;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    .icon-right {
      margin-right: 10px;
    }
    .title {
      font-size: 14px;
      color: #5d646e;
    }
  }
  .question-content {
    box-sizing: border-box;
    padding-left: 16px;
    background-color: #fff;
  }
  .question-content:last-child {
    border: none;
  }
}
</style>
